import { Component, OnInit, Renderer2 } from '@angular/core';


@Component({
  selector: 'app-accessibility',
  templateUrl: './accessibility.component.html'
})
export class AccessibilityComponent implements OnInit {

  constructor(private renderer: Renderer2) {}

  ngOnInit(): void {
    this.loadScript('https://cdn.jsdelivr.net/npm/jquery@3.6.0/dist/jquery.min.js');
    this.loadScript('assets/accessibility/Accessibility/js/accessibility.js');
  }

  loadScript(src: string) {
    const script = this.renderer.createElement('script');
    script.src = src;
    script.async = true;
    this.renderer.appendChild(document.body, script);
  }
}
